<template>
  <p class="item-description-bold-text">
    <TextWithLinks :text="text" link-class="item-description-bold-text__link" />
  </p>
</template>

<script>
import TextWithLinks from '../text/TextWithLinks.vue'

export default {
  name: 'ItemDescriptionBoldText',
  components: {
    TextWithLinks
  },
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.item-description-bold-text {
  @extend %body-bold;
  white-space: pre-wrap;
  letter-spacing: 0.28px;

  &__link {
    color: $link;
    word-break: break-all;
  }
}
</style>
